import React from 'react'
import { Element } from 'react-bulma-components'
import { Link } from 'react-router-dom'
import { createColumns } from '../utils'
import { getUserLabel } from '../../../../utils/users'
import { ColumnGroupDefinition } from '../types'

const workerColumnGroup = (): ColumnGroupDefinition => ({
  Header: ' ',
  id: 'user',
  className: 'sticky has-background-white',
  columns: createColumns([
    {
      header: 'Nom',
      id: 'user.name',
      className: 'sticky table-section-start-2x table-section-end',
      shouldMerge: true,
      render: ({ user }) => (
        <Element textWeight="bold">
          <Element renderAs={Link} to={`/workers/${user._id}`} textColor="primary">
            {getUserLabel(user)}
          </Element>
        </Element>
      ),
    },
  ]),
})

export default workerColumnGroup
